// theme/OrgThemeProvider.tsx
import { ThemeProvider, CssBaseline, createTheme } from "@mui/material";
import { useOrgContext } from "./OrgContext";

export const OrgThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { getCurrentOrgTheme, loading } = useOrgContext();
  const { primary, secondary } = getCurrentOrgTheme();

  const theme = createTheme({
    palette: {
      mode: "light",
      primary: { main: primary },
      secondary: { main: secondary },
    },
  });

  if (loading) return null;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
